// extracted by mini-css-extract-plugin
module.exports = {"header":"LoginModal__header___2PO_e","description":"LoginModal__description___1CbzZ"};